export const semanaProfissional = [
    "pro_hora_seg",
    "pro_hora_ter",
    "pro_hora_qua",
    "pro_hora_qui",
    "pro_hora_sex",
    "pro_hora_sab",
    "pro_hora_dom",
]